import React from "react";
import { Formik } from "formik";

import ReportNoteTemplateInputForm from "./ReportNoteTemplateInputForm";
import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";

import { withoutAttrs } from "utils/object";
import { ReportNoteTemplateSchema } from "schemas/reportNoteSchema";
import { upsertReportNoteTemplate } from "app/services/report_templates/reportNoteTemplateService";
import { showErrorToast, showSuccessToast } from "utils/toast";
import { filterNonUCHAccounts } from "utils/account.util";

const ReportNoteTemplateModal = (props) => {
  const {
    show,
    isEditMode,
    selectedRow,
    onCloseModal,
    selectorsData,
    fetchReportNoteTemplates,
  } = props;

  const filteredAccounts = filterNonUCHAccounts(selectorsData?.accounts || []);

  return (
    <ModalWrapper
      show={show}
      onClose={onCloseModal}
      title={isEditMode ? "Edit Report Template" : "Add Report Template"}
      titleStyle={{ fontWeight: 500, fontSize: 21 }}
    >
      <Formik
        initialValues={{
          ...selectedRow,
          _id: selectedRow?._id ?? "",
          status: selectedRow?.status ?? true,
          sections: selectedRow?.sections?.filter(Boolean) ?? [],
          account:
            selectedRow?.account ||
            (filteredAccounts?.length > 1
              ? selectedRow?.account
              : filteredAccounts?.[0]),
        }}
        initialErrors={{}}
        validateOnChange={true}
        validateOnBlur={true}
        validationSchema={ReportNoteTemplateSchema}
        onSubmit={async (values, { setSubmitting, resetForm }) => {
          setSubmitting(true);

          try {
            const { _id: device_group_id } =
              selectorsData?.deviceGroups?.find(
                (item) => item?.name === values?.device_group_name
              ) || {};

            const data = {
              ...values,
              device_group_id,
              display: true,
              sections: values.sections?.map((section) => section?._id),
            };

            const payload = withoutAttrs(data, [
              "_id",
              "tableData",
              "sectionIds",
              "device_group_name",
            ]);

            if (isEditMode) {
              payload.id = selectedRow?._id;
            }

            await upsertReportNoteTemplate(payload, isEditMode);

            await fetchReportNoteTemplates();
            onCloseModal();
            resetForm({ values: {} });
            showSuccessToast(
              isEditMode
                ? "Report Note Template updated successfully."
                : "Report Note Template added successfully.",
              false
            );
          } catch (error) {
            showErrorToast(error?.message ?? error);
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {(formikProps) => (
          <ReportNoteTemplateInputForm
            formikProps={formikProps}
            selectorsData={{ ...selectorsData, accounts: filteredAccounts }}
            onCloseModal={onCloseModal}
          />
        )}
      </Formik>
    </ModalWrapper>
  );
};

export default ReportNoteTemplateModal;
